import React from 'react'
import { connect } from 'react-redux'
import { uploadQuestionAnimatedGIF, uploadChoiceAnimatedGIF } from '../../prosemirror/utils/editorActions/addAnimatedGIF'
import EditorInsertGIFModal from '../../components/richEditor/editorUI/modals/EditorInsertGIFModal'
import { showNotification } from '../../actions/notifications'
import analytics from '../../utils/cdpAnalytics'

const MAX_FILE_SIZE = 20000000

class EditorInsertGIFModalContainer extends React.Component {
  constructor() {
    super()
    this.handleSelectFile = this.handleSelectFile.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown)
    analytics.page('Insert GIF Modal')
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown(e) {
    e.stopPropagation()
    if (e.keyCode === 27) { // escape key
      this.props.closeInsertImageModal()
    }
  }

  handleSelectFile(e) {
    const fileList = e.target.files
    const file = fileList[0]
    if (file.size > MAX_FILE_SIZE) {
      this.props.closeInsertImageModal()
      this.props.showNotification('The maximum file size you can upload is 20MB.', 'Sadly your GIF file is too large. ', 'destroy')
    } else {
      const {
        insertPos, isQuestion, questionPos, questionNode,
      } = this.props
      if (isQuestion) {
        this.props.uploadQuestionAnimatedGIF(insertPos, questionPos, questionNode, file)
      } else {
        this.props.uploadChoiceAnimatedGIF(insertPos, file)
      }
      this.props.closeInsertImageModal()
    }
  }

  render() {
    return (
      <div className='editor-insertImageModalContainer'>
        <EditorInsertGIFModal
          handleSelectFile={this.handleSelectFile}
          closeInsertImageModal={this.props.closeInsertImageModal}
        />
        <div onClick={this.props.closeInsertImageModal} className='editor-insertImageModalContainerBG' />
      </div>
    )
  }
}

function mapStateToProps() {
  return {}
}

export default connect(
  mapStateToProps,
  {
    uploadQuestionAnimatedGIF,
    uploadChoiceAnimatedGIF,
    showNotification,
  },
)(EditorInsertGIFModalContainer)
